import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockFilledSvg from "@ant-design/icons-svg/es/asn/UnlockFilled";
import AntdIcon from '../components/AntdIcon';
var UnlockFilled = function UnlockFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: UnlockFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(UnlockFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'UnlockFilled';
}
export default RefIcon;